<template>
  <!--
      	作者：luoyiming
      	时间：2020-06-25
      	描述：插件中心-限时拼团-抽奖列表-编辑抽奖-基本信息
      -->
  <div class="active-basic">
    <div class="common-form">基本信息</div>

    <el-form-item label="抽奖标题" prop="sweepstakes_name" :rules="[{ required: true, message: '请输入抽奖标题' }]">
      <el-input v-model="form.sweepstakes_name" placeholder="请输入抽奖标题" class="max-w460"></el-input>
    </el-form-item>

    <el-form-item label="抽奖广告" prop="image_id" :rules="rulesImage">
      <div class="d-c-c ad-picture" @click="openUpload">
        <img v-if="form.image_id > 0" :src="form.file_path" width="300" height="124" />
        <span v-else class="el-icon-picture-outline"></span>
      </div>

    </el-form-item>
    <el-form-item label="抽奖转盘图片" prop="turntable_id" :rules="rulesTurntable">
      <div class="d-c-c ad-picture" @click="openTurntableUpload">
        <img v-if="form.turntable_id > 0" :src="form.turntable_path" width="300" height="124" />
        <span v-else class="el-icon-picture-outline"></span>
      </div>

    </el-form-item>
    <el-form-item label="抽奖类型">
      <el-radio-group v-model="form.type">
        <el-radio :label="10">大转盘</el-radio>
        <el-radio :label="20">九宫格</el-radio>
        <el-radio :label="30">盲盒</el-radio>
      </el-radio-group>
    </el-form-item>
	<el-form-item label="选择抽奖等级">
	  <el-checkbox-group v-model="form.grade_limit">
	    <el-checkbox v-for="(item,index) in form.gradeList" :key="index" :label="item.grade_id" >{{item.name}}</el-checkbox>
	  </el-checkbox-group>
	  <div class="gray9">选中的等级用户才能抽奖品,全部未选择则不生效</div>

	</el-form-item>
    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
    <Upload v-if="isturntable" :isturntable="isturntable" @returnImgs="returnTurntableFunc">上传图片</Upload>
  </div>
</template>

<script>
import Upload from '@/components/file/Upload';
export default {
  components: {
    /*选择商品组件*/
    Upload,

  },
  data() {
    /*验证图片是否上传*/
    const validatorImages = (rule, value, callback) => {
      if (value < 1) {
        return callback(new Error('请上传抽奖图'));
      } else {
        callback();
      }
    };
    /*验证转盘图片是否上传*/
    const validatorTurntable = (rule, value, callback) => {
      if (value < 1) {
        return callback(new Error('请上传抽奖转盘图'));
      } else {
        callback();
      }
    };
    return {

      /*是否上传图片*/
      isupload: false,
      isturntable:false,
      /*图片是否上传了*/
      rulesImage: [{ validator: validatorImages, required: true, message: '请上传抽奖广告图片', trigger: 'change' }],
      rulesTurntable: [{ validator: validatorTurntable, required: true, message: '请上传抽奖转盘图片', trigger: 'change' }]
    };
  },
  props: ['form'],
  methods: {


    /*上传*/
    openUpload(e) {
      this.isupload = true;
    },
    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        this.form.file_path = e[0].file_path;
        this.form.image_id = e[0].file_id;
      }
      this.isupload = false;
     },
     /*上传*/
     openTurntableUpload(e) {
       this.isturntable = true;
     },
     /*获取图片*/
     returnTurntableFunc(e) {
       if (e != null && e.length > 0) {
         this.form.turntable_path = e[0].file_path;
         this.form.turntable_id = e[0].file_id;
       }
       this.isturntable = false;
      }
  }
};
</script>

<style lang="scss">
.active-basic .ad-picture {
  width: 300px;
  height: 124px;
  border-radius: 16px;
  font-size: 40px;
  border: 1px dashed #cccccc;
  color: $blue;
  cursor: pointer;
  overflow: hidden;
}
.active-basic .ad-picture:hover {
  border: 1px dashed $blue;
}

.active-basic .ad-picture img {
  object-fit: fill;
}
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  line-height: 20px;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/sweepstakes/sweepstakes/part/Basic.vue